<template>
    <div class="disclaimer-wrapper primary-bd-ee" ref='sign1'>
        <span class="content sub-text-99">{{propsData.disclaimer}}</span>
    </div>
</template>

<script>
import * as actions from '@/common/js/api.js'

export default {
    name: '',
    data() {
        return {
            model: {
                showFlag: false,
                disclaimer: "本文转载上述内容出于传递更多信息之目的，不代表同花顺财经观点。同花顺力求但不保证数据的完全准确，如有错漏请以证监会指定上市公司信息披露平台为准，各类信息服务基于人工智能算法，投资者据此操作，风险自担。",
                seq: 654,
            },
            // showReport: getAccoun
        }
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    disclaimer: '以上资讯由同花顺AI写手完成，写作系统尚处于测试阶段，内容仅供参考，同花顺力求但不保证数据的完全准确，如有错漏请以证监会指定上市公司信息披露平台为准。',
                    seq: '615868644'
                }
            }
        }
    },

}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';

.disclaimer-wrapper {
    font-size: 12px;
    line-height: 24px;
    padding-top: 8px;
    border-top-width: 1px;
    border-top-style: solid;
    position: relative;
    // padding-bottom: 5px;
    > span {
        &.reportingBtn {
            float: right;
            cursor: pointer;
        }
    }
    .reportingTab {
        width: 100px;
        height: 244px;
        z-index: 100000;
        position: absolute;
        right: 0;
        bottom: 20px;
        border-radius: 2px;
        text-indent: 10px;
        > div {
            width: 100%;
            height: 34px;
            font-size: 12px;
            line-height: 34px;
            border-bottom-width: 1px;
            border-bottom-style: solid;
            cursor: pointer;
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
